import { render, staticRenderFns } from "./SidebarTop.vue?vue&type=template&id=0fb62dd4&scoped=true"
import script from "./SidebarTop.vue?vue&type=script&lang=js"
export * from "./SidebarTop.vue?vue&type=script&lang=js"
import style0 from "./SidebarTop.vue?vue&type=style&index=0&id=0fb62dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb62dd4",
  null
  
)

export default component.exports